import { Object3D } from "three";

export class PlacementObject extends Object3D {

    constructor() {
        super();
    }
}
